// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__lMjR9","boxTitle":"Qualiphy_boxTitle__2na9a","box":"Qualiphy_box__B7aNv","toggleWrap":"Qualiphy_toggleWrap__2tk_8"};